export default "__VITE_ASSET__CuGqzg_k__"